import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation UpdateSupplierMutation($data: SupplierUpdateInput!) {
        updateSupplier(data:$data) {
            id
      }
    }
  `

export default (data, callback) => {
    const variables = {
        data
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.updateSupplier })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}